import { TabSection } from './TabSection'
import type { ChannelConfigUpdate } from '../../types'
import styles from './DigestTab.module.css'

interface Props {
  draft: {
    weeklyDigestEnabled: boolean
    personalDigestEnabled: boolean
  }
  onChange: (patch: Partial<ChannelConfigUpdate>) => void
}

export function DigestTab({ draft, onChange }: Props) {
  return (
    <TabSection
      accent="purple"
      icon="bar_chart"
      title="Digest"
      subtitle="Weekly summaries delivered to the channel and to individual engineers"
    >
      <div className={styles.grid}>
        <div className={`${styles.card} ${draft.weeklyDigestEnabled ? styles.cardOn : ''}`}>
          <div className={styles.cardHeader}>
            <div className={styles.cardInfo}>
              <div className={styles.cardLabel}>Weekly channel digest</div>
              <div className={styles.cardHint}>Post a Monday morning PR summary to this channel, timed to your configured timezone</div>
            </div>
            <label className={styles.toggle}>
              <input
                type="checkbox"
                checked={draft.weeklyDigestEnabled}
                onChange={e => onChange({ weeklyDigestEnabled: e.target.checked })}
              />
              <div className={styles.track} />
              <div className={styles.thumb} />
            </label>
          </div>
          <div className={styles.previewImg}>
            <img src="/digest-channel.png" alt="Weekly channel digest example" />
          </div>
        </div>

        <div className={`${styles.card} ${draft.personalDigestEnabled ? styles.cardOn : ''}`}>
          <div className={styles.cardHeader}>
            <div className={styles.cardInfo}>
              <div className={styles.cardLabel}>Personal PR digest</div>
              <div className={styles.cardHint}>DM each engineer their personal PR stats for the last week on Monday morning, timed to your configured timezone</div>
            </div>
            <label className={styles.toggle}>
              <input
                type="checkbox"
                checked={draft.personalDigestEnabled}
                onChange={e => onChange({ personalDigestEnabled: e.target.checked })}
              />
              <div className={styles.track} />
              <div className={styles.thumb} />
            </label>
          </div>
          <div className={styles.previewImg}>
            <img src="/digest-personal.png" alt="Personal PR digest example" />
          </div>
        </div>
      </div>
    </TabSection>
  )
}
